import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import CascadeListScreen from '../CascadeListScreen';
import CascadeScreen from '../CascadeScreen';
import NewTaskScreen from '../NewTaskScreen';
import NewPromiseScreen from '../NewPromiseScreen';
import RevisionActScreen from '../RevisionActScreen';
import NewInvoiceScreen from '../NewInvoiceScreen';
import ClaimScreen from '../ClaimScreen';

const CascadeRoute = () => {
  const { path } = useRouteMatch();

  return (
    <>
      <Switch>
        <Route path={`${path}/:entityId/revisionAct`} exact>
          <RevisionActScreen />
        </Route>
        <Route path={`${path}/:entityId/claim`} exact>
          <ClaimScreen />
        </Route>
        <Route path={`${path}/:entityId/newInvoice`} exact>
          <NewInvoiceScreen />
        </Route>
        <Route path={`${path}/:entityId/history/new`} exact>
          <NewPromiseScreen />
        </Route>
        <Route path={`${path}/:entityId/tasks/new`} exact>
          <NewTaskScreen />
        </Route>
        <Route path={path} exact>
          <CascadeListScreen />
        </Route>
        <Route path={`${path}/:entityId`}>
          <CascadeScreen />
        </Route>
      </Switch>
    </>
  );
};

export default CascadeRoute;
